module.exports = __webpack_public_path__ + "img/back.b8cc77d4.png";